!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.ky = t());
}(this, function () {
  "use strict";

  return [{
    locale: "ky",
    pluralRuleFunction: function (e, t) {
      return t ? "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "жыл",
        relative: {
          0: "быйыл",
          1: "эмдиги жылы",
          "-1": "былтыр"
        },
        relativeTime: {
          future: {
            one: "{0} жылдан кийин",
            other: "{0} жылдан кийин"
          },
          past: {
            one: "{0} жыл мурун",
            other: "{0} жыл мурун"
          }
        }
      },
      "year-short": {
        displayName: "ж.",
        relative: {
          0: "быйыл",
          1: "эмдиги жылы",
          "-1": "былтыр"
        },
        relativeTime: {
          future: {
            one: "{0} жыл. кийин",
            other: "{0} жыл. кийин"
          },
          past: {
            one: "{0} жыл мурун",
            other: "{0} жыл мурун"
          }
        }
      },
      month: {
        displayName: "ай",
        relative: {
          0: "бул айда",
          1: "эмдиги айда",
          "-1": "өткөн айда"
        },
        relativeTime: {
          future: {
            one: "{0} айдан кийин",
            other: "{0} айдан кийин"
          },
          past: {
            one: "{0} ай мурун",
            other: "{0} ай мурун"
          }
        }
      },
      "month-short": {
        displayName: "ай",
        relative: {
          0: "бул айда",
          1: "эмдиги айда",
          "-1": "өткөн айда"
        },
        relativeTime: {
          future: {
            one: "{0} айд. кийин",
            other: "{0} айд. кийин"
          },
          past: {
            one: "{0} ай мурун",
            other: "{0} ай мурун"
          }
        }
      },
      day: {
        displayName: "күн",
        relative: {
          0: "бүгүн",
          1: "эртең",
          2: "бүрсүгүнү",
          "-2": "мурдагы күнү",
          "-1": "кечээ"
        },
        relativeTime: {
          future: {
            one: "{0} күндөн кийин",
            other: "{0} күндөн кийин"
          },
          past: {
            one: "{0} күн мурун",
            other: "{0} күн мурун"
          }
        }
      },
      "day-short": {
        displayName: "күн",
        relative: {
          0: "бүгүн",
          1: "эртең",
          2: "бүрсүгүнү",
          "-2": "мурдагы күнү",
          "-1": "кечээ"
        },
        relativeTime: {
          future: {
            one: "{0} күн. кийин",
            other: "{0} күн. кийин"
          },
          past: {
            one: "{0} күн мурун",
            other: "{0} күн мурун"
          }
        }
      },
      hour: {
        displayName: "саат",
        relative: {
          0: "ушул саатта"
        },
        relativeTime: {
          future: {
            one: "{0} сааттан кийин",
            other: "{0} сааттан кийин"
          },
          past: {
            one: "{0} саат мурун",
            other: "{0} саат мурун"
          }
        }
      },
      "hour-short": {
        displayName: "ст",
        relative: {
          0: "ушул саатта"
        },
        relativeTime: {
          future: {
            one: "{0} саат. кийин",
            other: "{0} саат. кийин"
          },
          past: {
            one: "{0} саат. мурун",
            other: "{0} саат. мурун"
          }
        }
      },
      minute: {
        displayName: "мүнөт",
        relative: {
          0: "ушул мүнөттө"
        },
        relativeTime: {
          future: {
            one: "{0} мүнөттөн кийин",
            other: "{0} мүнөттөн кийин"
          },
          past: {
            one: "{0} мүнөт мурун",
            other: "{0} мүнөт мурун"
          }
        }
      },
      "minute-short": {
        displayName: "мүн.",
        relative: {
          0: "ушул мүнөттө"
        },
        relativeTime: {
          future: {
            one: "{0} мүн. кийин",
            other: "{0} мүн. кийин"
          },
          past: {
            one: "{0} мүн. мурун",
            other: "{0} мүн. мурун"
          }
        }
      },
      second: {
        displayName: "секунд",
        relative: {
          0: "азыр"
        },
        relativeTime: {
          future: {
            one: "{0} секунддан кийин",
            other: "{0} секунддан кийин"
          },
          past: {
            one: "{0} секунд мурун",
            other: "{0} секунд мурун"
          }
        }
      },
      "second-short": {
        displayName: "сек.",
        relative: {
          0: "азыр"
        },
        relativeTime: {
          future: {
            one: "{0} сек. кийин",
            other: "{0} сек. кийин"
          },
          past: {
            one: "{0} сек. мурун",
            other: "{0} сек. мурун"
          }
        }
      }
    }
  }];
});